import styled from 'styled-components';

import { useTranslate } from '@dreryk/react-common';
import {
   ActionBar,
   appendTestableElementAttributes,
   ButtonVariant,
   FormContent,
   Message,
   MessageType,
   StyledFlex,
   TextView,
} from '@dreryk/react-components';

import { StyledFormSectionHeader } from '../../../common/StyledFormSectionHeader';
import { healthcarePracticeTranslationKeys, healthcareProviderTranslationKeys } from '../../../translations';
import { HealthcareInstitutionLogo } from '../../common/HelathcareInstitutionLogo/HealthcareInstitutionLogo';
import { RegisterBookNumberTextView } from '../../common/RegisterBookNumberTextView';
import { HealthcarePracticeBasicData } from '../common/HealthcarePracticeBasicData';
import { HealthcarePracticeFormBean } from '../common/healthcarePractice';

import { StyledHealthcarePracticeDataPanelPracticeDetails } from './HealthcarePracticeDataPanelPracticeDetails.styled';
import { ServiceProvidingLocationTable } from './serviceProvidingLocation/ServiceProvidingLocationTable';

export const StyledHealthcarePracticeData = styled.div`
   max-width: 800px;
   display: flex;
   gap: 120px;
`;

StyledHealthcarePracticeData.displayName = 'StyledHealthcarePracticeData';

type HealthcarePracticeDataPanelProps = {
   readonly healthcarePractice: HealthcarePracticeFormBean;
   readonly onUpdateClicked: VoidFunction;
   readonly dataChanged: boolean;
};

export const HealthcarePracticeDataPanel = (props: HealthcarePracticeDataPanelProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <FormContent testId={'practiceDataPanel'}>
         <StyledHealthcarePracticeDataPanelPracticeDetails {...appendTestableElementAttributes('practiceData')}>
            <StyledFlex gap={148} {...appendTestableElementAttributes('healthcarePractice')}>
               <RegisterBookNumberTextView value={props.healthcarePractice.registerBookNumber} />

               <TextView label={healthcarePracticeTranslationKeys.medicalChamber} testId={'medicalChamberCode'}>
                  {props.healthcarePractice.medicalChamber?.name ?? translate(healthcareProviderTranslationKeys.noData)}
               </TextView>
            </StyledFlex>
            {props.healthcarePractice.logo ? (
               <HealthcareInstitutionLogo fileDescriptor={props.healthcarePractice.logo} />
            ) : (
               <div />
            )}
            <HealthcarePracticeBasicData {...props.healthcarePractice} />
         </StyledHealthcarePracticeDataPanelPracticeDetails>
         <ActionBar.PrimaryButton
            testId='practiceDataUpdate'
            label={healthcarePracticeTranslationKeys.editPracticeData}
            onClick={props.onUpdateClicked}
            variant={ButtonVariant.PRIMARY}
         />
         <FormContent testId={'serviceProvidingLocations'}>
            <StyledFormSectionHeader>
               {translate(healthcarePracticeTranslationKeys.serviceProvidingLocation)}
            </StyledFormSectionHeader>
            {props.dataChanged ? (
               <div>
                  <Message
                     type={MessageType.WARNING}
                     displayIndicator
                     fullWidth={false}
                     label={healthcarePracticeTranslationKeys.verifyServiceProvidingLocationDataCorrectness}
                     testId={'verifyServiceProvidingLocationDataCorrectness'}
                  />
               </div>
            ) : null}
            <ServiceProvidingLocationTable healthcarePractice={props.healthcarePractice} />
         </FormContent>
      </FormContent>
   );
};
